// src/components/ResultPanel.jsx
import React from "react";
import { FiDownload, FiX } from "react-icons/fi";

const ResultPanel = ({ open, onClose, result, onDownloadFailed }) => {
  // UPDATED: Check for 'importedCount' (from frontend calculation) 
  // or 'inserted' (if backend returns it)
  const inserted = result?.importedCount ?? result?.inserted ?? 0;
  
  const failed = result?.failed ?? [];

  return (
    <>
      {/* backdrop */}
      <div
        className={`fixed inset-0 bg-black/30 transition-opacity ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        onClick={onClose}
      />

      {/* slide-in panel */}
      <div
        className={`fixed right-0 top-0 h-full w-full sm:w-[480px] bg-white shadow-xl transform transition-transform ${open ? "translate-x-0" : "translate-x-full"}`}
        style={{ zIndex: 60 }}
      >
        <div className="p-5 border-b flex items-center justify-between">
          <h3 className="text-lg font-semibold">Import Results</h3>
          <div className="flex items-center gap-2">
            
            {/* UPDATED: Only show Download button if there are failures */}
            {failed.length > 0 && (
                <button
                onClick={() => onDownloadFailed && onDownloadFailed()}
                className="flex items-center gap-2 px-3 py-2 bg-sky-700 text-white rounded hover:bg-sky-800 transition"
                title="Download failed rows"
                >
                <FiDownload /> Download Failed
                </button>
            )}

            <button onClick={onClose} className="p-2 text-gray-600 rounded hover:bg-gray-100">
              <FiX />
            </button>
          </div>
        </div>

        <div className="p-5 space-y-4 overflow-y-auto h-[calc(100%-72px)]">
          
          {/* SUCCESS CARD */}
          <div className="p-4 bg-green-50 rounded-lg border border-green-100">
            <div className="text-sm text-green-800 font-medium">Successfully Imported</div>
            <div className="text-3xl font-bold text-green-700">{inserted}</div>
          </div>

          {/* FAILED CARD */}
          <div className={`p-4 rounded-lg border ${failed.length > 0 ? 'bg-red-50 border-red-100' : 'bg-gray-50 border-gray-200'}`}>
            <div className="flex items-center justify-between">
              <div>
                <div className={`text-sm font-medium ${failed.length > 0 ? 'text-red-800' : 'text-gray-500'}`}>Failed Rows</div>
                <div className={`text-3xl font-bold ${failed.length > 0 ? 'text-red-700' : 'text-gray-400'}`}>{failed.length}</div>
              </div>
            </div>

            {failed.length > 0 && (
              <div className="mt-4">
                <div className="text-sm text-red-800 mb-2 font-medium">Failure Details (First 20)</div>
                <div className="space-y-2 max-h-64 overflow-auto pr-1">
                  {failed.slice(0, 20).map((f, idx) => (
                    <div key={idx} className="p-3 bg-white border border-red-100 rounded flex items-start gap-3 shadow-sm">
                      <div className="text-xs font-bold text-red-500 w-12 pt-0.5">Row {f.row ?? "—"}</div>
                      <div className="flex-1">
                        <div className="text-sm font-semibold text-gray-800">{f.email || f.primary_contact_email || "No Email"}</div>
                        <div className="text-xs text-red-600 mt-1">{f.failure_reason || f.reason || "Unknown Error"}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {failed.length === 0 && inserted > 0 && (
            <div className="p-4 rounded bg-green-100 text-green-800 border border-green-200 text-center font-medium">
              🎉 Complete Success! All clients were imported.
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ResultPanel;